<template lang="pug">
.sv(
	:class="[{'sv--app': isApp}]"
)
	Loading(v-if="loading && !isApp")
	StandingsTable(
		v-else
		v-show = "standings.length"
		:standings = "standings"
	)
</template>

<style lang="sass">

.sv
	display: flex
	justify-content: center
	align-items: flex-start
	height: 100%
	overflow-x: auto
	background-color: $white

</style>

<script>
import api from "@/api/index";

import Loading from "@/components/subcomponents/general/Loading.vue";
import StandingsTable from "@/components/subcomponents/StandingsTable.vue";

export default {
	name: "Standings",
	metaInfo() {
		return {
			title: `${this.$i18n.t("Standings")} | ACB Live`,
			meta: [
				{
					name: "description",
					content: this.$i18n.t("meta_description"),
				},
			],
		};
	},
	data() {
		return {
			loading: true,
			lang: this.$store.state.general.lang,
			actual: {
				year: "",
				competition: "",
				edition: "",
				round: "",
				phase: "",
			},
			standings: [],
		};
	},
	computed: {
		isApp() {
			return this.$store.state.general.isApp;
		},
		refreshSignal() {
			return this.$store.state.general.refreshSignal;
		},
	},
	methods: {
		updateStandings() {
			api.competition.getActualStandings().then((data) => {
				if (data) {
					this.$data.standings = data;
					this.$data.loading = false;
				}
			});
		},
	},
	watch: {
		lang(newValue) {
			this.$store.commit("general/setLang", newValue);
			this.$router.replace({ name: newValue + ".standings" });
		},
		refreshSignal(newValue) {
			if (newValue) {
				this.updateStandings();
			}
		},
	},
	created() {
		this.updateStandings();
		this.$store.commit("general/setRefreshSignal");
	},
	components: {
		Loading,
		StandingsTable,
	},
};
</script>
